import { type Locale } from 'vue-i18n'

export default defineNuxtPlugin((nuxtApp) => {
  const locale = useCookie<Locale>('i18n_redirected')

  if (locale.value) {
    if (!nuxtApp.vueApp.$nuxt.$i18n) {
      console.warn('[default-locale.ts] i18n plugin not found, cannot set locale')
    }
    nuxtApp.vueApp.$nuxt.$i18n?.setLocale(locale.value)
  }
})
